// ProtectedDriverRoute.jsx
import { Navigate } from "react-router-dom";
import { getAccessToken } from "./DriverAuth";

export default function ProtectedDriverRoute({ children }) {
  const token = getAccessToken();

  if (!token) {
    return <Navigate to="/driver/login" replace />;
  }

  return children;
}
